import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import SMORoomEditBaseFragment from './SMORoomEditBaseFragment';
import SMConst from 'lib/SMConst';
import SMDropDownButton from 'components/dashboard/form/SMDropDownButton';
import SMORoomCalendarHeaderView from './SMORoomCalendarHeaderView';
import SMMonthCalendar from 'components/dashboard/calendar/SMMonthCalendar';
import SMORoomUnavailabilityListView from './SMORoomUnavailabilityListView';
import SMORoomExceptionListView from './SMORoomExceptionListView';
import SMOAcademyLinkBaloonView from 'components/dashboard/owners/SMOAcademyLinkBaloonView';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMORoomExceptionCalendarBaloon from 'components/dashboard/calendar/SMORoomExceptionCalendarBaloon';
import SMORoomUnavailabilityCalendarBaloon from 'components/dashboard/calendar/SMORoomUnavailabilityCalendarBaloon';
import SMOPlanEditView from './SMOPlanEditView';
import SMPlanHelper from 'components/helpers/SMPlanHelper';

class SMORoomEditPlanFragment extends SMORoomEditBaseFragment {
  
  constructor(props) {
    super(props);
    this.state = {
      calendar: [],  
      year: new Date().getFullYear(),
      month: new Date().getMonth(),
      room: this.props.room,
      isCurrent : this.isCurrent(this.props),
      errors: this.props.errors,
      selectedCalendar: SMConst.CalendarType.Availability,
      editStyle: 'calendar', // or 'list'
    };
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    if ((this.state.selectedCalendar == SMConst.CalendarType.HourlyPrice && !SMPlanHelper.hasHourlyPrice(nextProps.plan)) ||
        (this.state.selectedCalendar == SMConst.CalendarType.DailyPrice && !SMPlanHelper.hasDailyPrice(nextProps.plan))) {
      this.setState({selectedCalendar: SMConst.CalendarType.Availability});
    }
    
    this.setState({
      isCurrent : this.isCurrent(nextProps),
      room : nextProps.room,
    });
    setTimeout(()=>{
      if (this.state.isCurrent) {
        this.refreshCalendar(this.state.year, this.state.month);
      }
    }, 10);
  }
  
  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  toggleEditStyle() {
    this.setState({
      editStyle: this.state.editStyle == 'calendar' ? 'list' : 'calendar'
    });
  }
  
  calendarStyle() {
    return {
      display: this.state.editStyle == 'calendar' ? "block" : "none"
    };
  }
  
  listStyle() {
    return {
      display: this.state.editStyle == 'list' ? "block" : "none"
    };
  }

  refreshCalendar(year, month) {
    let queries = {
      year: year,
      month: month + 1 // railsとjsでDate型の月のoffset開始値が違うので1加算する. js[0-11] rails[1-12]
    };
    if (this.props.plan && this.props.room != this.props.plan) {
      queries.plan_id = this.props.plan.id;
    }

    SMOwnerResource.getRoomCalendar(this.props.room.owner_id, this.props.room.id, queries, (calendar, error)=>{
      if(!error) {
        this.setState({
          year: year,
          month: month,
          calendar : calendar
        });
      }
    });
  }
  
  formDidUpdate(e) {
    this.refreshCalendar(this.state.year, this.state.month);
    this.props.delegate.formDidUpdate(e);
  }
  
  priceSelectDidChange(value) {
    this.setState({selectedCalendar: parseInt(value)});
  }
  
  calendarSelectBoxValueDidChange(year, month) {
    this.refreshCalendar(year, month);
  }

  
  subMenuItemDidSelectRowAtIndex(rowIndex){
    if (this.props.planIndex >= 0) {
      switch (rowIndex) {
        case 0:
          if(this.props.delegate && typeof this.props.delegate.deletePlan === 'function'){
            this.props.delegate.deletePlan(this.props.plan.id);
          }
          break;
        case 1:
          if(this.props.delegate && typeof this.props.delegate.addNewPlanDidSelect === 'function'){
            this.props.delegate.addNewPlanDidSelect();
          }
          break;
      }
    } else {
      if(this.props.delegate && typeof this.props.delegate.addNewPlanDidSelect === 'function'){
        this.props.delegate.addNewPlanDidSelect();
      }
    }
  }
  
  addListItemDidClick(e) {
    e.preventDefault();
    let baloon;
    
    if (this.state.selectedCalendar == SMConst.CalendarType.Availability) {
      baloon = <SMORoomUnavailabilityCalendarBaloon
        selectedDate={this.props.today}
        selectedCalendar={this.state.selectedCalendar}
        clientX={e.clientX}
        clientY={e.clientY}
        room={this.props.room}
        plan={this.props.plan}
        delegate={this.props.delegate} />;
    } else {
      baloon = <SMORoomExceptionCalendarBaloon
        selectedDate={this.props.today}
        selectedCalendar={this.state.selectedCalendar}
        clientX={e.clientX}
        clientY={e.clientY}
        room={this.props.room}
        plan={this.props.plan}
        delegate={this.props.delegate} />;
    }
    
    ReactDOM.render(baloon, document.getElementById('js-baloon-container'));
  }
  
  menuButtonDidSelect(e) {
    e.preventDefault();
    this.showDialog(
      <SMOPlanEditView room={this.state.room} model={this.props.plan} delegate={this} planIndex={this.props.planIndex} errors={this.props.errors} />
    );
  }
  
  planEditDidCompleted(e) {
    e.preventDefault();
    this.hideDialog();
  }
  
  holidayDidClick() {
    if(this.props.delegate && typeof this.props.delegate.tableDidSelectRowAtIndex === 'function') {
      this.props.delegate.holidayDidClick();
    }
  }

  render() {
    let subMenuItems = this.props.planIndex >= 0 ? [{title: 'プランを削除', link: "#"}] : [];
    subMenuItems.push({title: '新しいプランを追加', link: "#"});
    
    return (
      <div ref="fragment" style={this.fragmentStyle()}>
        <div className="calendar-header" style={{position:"relative"}}>
          <SMDropDownButton title='プランを編集' link='#' subMenuItems={subMenuItems} delegate={this} />
          <h2 className="dashboard-title mb20 mr150">
            <span className="icon-form icon-form__optional">任意</span>{this.props.plan.plan_name}
            <span className="dashboard-title__supplement ml15">
              日時ごとに利用可否の設定や価格の設定をすることができます。
            </span>
          </h2>
        </div>

        <SMORoomCalendarHeaderView room={this.props.room} plan={this.props.plan} editStyle={this.state.editStyle} today={this.props.today} year={this.state.year} month={this.state.month} selectedCalendar={this.state.selectedCalendar} delegate={this} />
        <div style={this.calendarStyle()}>
          <SMMonthCalendar items={this.state.calendar} today={this.props.today} room={this.props.room} plan={this.props.plan} selectedCalendar={this.state.selectedCalendar} delegate={this} />
        </div>
        <div style={this.listStyle()}>
          {this.state.selectedCalendar == SMConst.CalendarType.Availability ? <SMORoomUnavailabilityListView room={this.props.room} plan={this.props.plan} delegate={this} />
                                                                            : <SMORoomExceptionListView room={this.props.room} plan={this.props.plan} selectedCalendar={this.state.selectedCalendar} delegate={this} />}
        </div>
        
        <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
          <a href="#" className="button button-green maincol-buttonarea__button" onClick={this.didSelectNextFragment.bind(this)}>次へ</a>
        </div>
        <SMOAcademyLinkBaloonView displayPlace={SMConst.AcademyLinkDisplayPlace.RoomPlan} isCurrent={this.state.isCurrent} />
      </div>
    );
  }
}

SMORoomEditPlanFragment.propTypes = {
  today: PropTypes.instanceOf(Date).isRequired,
  plan: PropTypes.object.isRequired,
  planIndex: PropTypes.number.isRequired,
};
SMORoomEditPlanFragment.defaultProps = {
  errors: [],
};

export default SMORoomEditPlanFragment;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMORoomEditPlanFragment.jsx